<h1 mat-dialog-title>{{ 'NEW-FIELD-DIALOG.TITLE' | translate }}</h1>
<div mat-dialog-content>
  <p>{{ 'NEW-FIELD-DIALOG.SELECT-ACTION' | translate }}</p>
</div>
<div mat-dialog-actions>
  <button class="new-field-btn" mat-flat-button (click)="addField()">{{ 'NEW-FIELD-DIALOG.ADD-FIELD' | translate }}</button>
  <button class="new-field-btn" mat-flat-button (click)="editField()">{{ 'NEW-FIELD-DIALOG.EDIT-FIELD' | translate }}</button>
  <button class="new-field-btn" mat-flat-button (click)="redraw()">{{ 'NEW-FIELD-DIALOG.REDRAW' | translate }}</button>
</div>
